import { dialogue } from "../../uiComponents/dialogue.js";
import { playerState } from "../../state/stateManagers.js";

const swordHaiku = [
  "Edge of silent steel—\nOnce swung in forgotten wars.\nNow yours to protect.",
];

export function generateSwordComponents(k, pos) {
  return [
    k.sprite("assets", {
      anim: "sword",
    }),
    k.area({ shape: new k.Rect(k.vec2(0, 0), 20, 20) }),
    k.body({ isStatic: true }),
    k.pos(pos),
    k.z(1),
    k.scale(1),
    "item",
    { itemName: "sword" },
  ];
}

export async function startSwordInteraction(k, itemObj, interactPrompt) {
  const header = "Old Katana";

  await dialogue(
    k,
    k.vec2(0, 0),
    swordHaiku,
    true,
    null,
    [],
    null,
    header
  );

  k.play("soundUI", { volume: 0.4 });

  playerState.setHasSword?.(true);             // In-game flag
  playerState.setHasPickedUpSword?.(true);     // Persistent flag

  interactPrompt.hide();
  k.destroy(itemObj);
}
